//轮播图接口

import request from '../request';

//新增
export const reqAddData = (data) => request({ url:'/admin/upload/banner', method:'post', params:data });

//查询全部数据
export const reqGetAllData = () => request({ url:'/admin/banner/all', method:'get' });

//删除
export const reqDeleteData = (id) => request({ url:`/admin/banner/delete/${id}`, method:'delete'});

//调整状态
export const reqUpdateStatus = (status, id) => request({ url:`/admin/banner/status/${status}/${id}`, method:'post' });
